import { useCarInsuranceContext } from './index';

export function useSafeCarInsuranceContext() {
  try {
    return useCarInsuranceContext();
  } catch {
    return null;
  }
}
